import io from 'socket.io-client';
var RtcClient = /** @class */ (function () {
    function RtcClient() {
        this.connected = false;
    }
    Object.defineProperty(RtcClient, "instance", {
        // #region singleton implementation
        get: function () {
            if (!this._instance) {
                this._instance = new RtcClient();
            }
            return this._instance;
        },
        enumerable: false,
        configurable: true
    });
    // #region public methods
    /**
     * Connect to Realtime API whenever the client is ready, e.g. after login
     *
     * @param {string} url The root endpoint of the rtc API
     * @param {string} jwt The JSON Web Token to authenticate against API
     */
    RtcClient.prototype.connect = function (url, jwt) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // Connect to Realtime API
            _this.socket = io(url, {
                query: { jwt: jwt },
                transports: ['websocket']
            });
            _this.socket.on('connect', function () {
                console.log('Connected to realtime API');
                _this.connected = true;
                return resolve();
            });
            _this.socket.on('connect_error', function (err) {
                console.log(err);
                reject(err);
            });
            _this.socket.on('error', function (err) { return console.log(err); });
        });
    };
    /**
     * Disconnect from Realtime API. This is necessary whenever the user logs out
     */
    RtcClient.prototype.disconnect = function () {
        this.connected = false;
        if (!this.socket) {
            return;
        }
        this.socket.disconnect();
    };
    RtcClient.prototype.register = function (event, callback) {
        if (!this.socket) {
            return;
        }
        this.socket.on(event, callback);
    };
    RtcClient.prototype.unregister = function (event) {
        if (!this.socket) {
            return;
        }
        this.socket.off(event);
    };
    RtcClient.prototype.emit = function (event, data) {
        if (!this.socket) {
            return;
        }
        this.socket.emit(event, data);
    };
    return RtcClient;
}());
export default RtcClient;
//# sourceMappingURL=RtcClient.js.map